var exports = {
  "T": "MobileCta__QblLNu",
  "m": "MobileCta__message__VrMuCg",
};

module.exports = exports;
